module.exports = __webpack_public_path__ + "static/img/surveys.0d7c7b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/surveys.png
// module id = 2TxG
// module chunks = 0